import React from 'react';
import { Fade } from 'react-reveal';
import './ContactGreeting.css';
import SocialMedia from '../socialmedia/SocialMedia';
import Button from '../buttons/Button';
import { contactPageData } from './contacts';
import AddressImg from './AddressImg';

const ContactGreeting = () => {
  const ContactData = contactPageData.contactSection;
  const addressSection = contactPageData.addressSection;
  const phoneSection = contactPageData.phoneSection;
  return (
    <div className='contact-main'>
      <div className='basic-contact'>
        <Fade bottom duration={1000} distance='40px'>
          <div className='contact-heading-div'>
            <div className='contact-heading-img-div'>
              <img src={require('../../../img/julles.jpg')} alt='' />
            </div>
            <div className='contact-heading-text-div'>
              <h1
                className='contact-heading-text'
                // style={{ color: theme.text }}
              >
                {ContactData['title']}
              </h1>
              <p
                className='contact-header-detail-text subTitle'
                // style={{ color: theme.secondaryText }}
              >
                {ContactData['description']}
              </p>
              <SocialMedia />
              <div className='resume-btn-div'>
                <Button
                  text='See My Resume'
                  newTab={true}
                  href='https://drive.google.com/file/d/1BMnX5lIho7MJla1Cd79nZu1YELqLPhEV/view?usp=sharing'
                />
              </div>
            </div>
          </div>
        </Fade>
        <Fade bottom duration={1000} distance='40px'>
          <div className='address-heading-div'>
            <div className='address-heading-text-div'>
              <h1
                className='address-heading-text'
                // style={{ color: theme.text }}
              >
                {addressSection['title']}
              </h1>
              <p
                className='contact-header-detail-text subTitle'
                // style={{ color: theme.secondaryText }}
              >
                {addressSection['subtitle']}
              </p>
              <h1
                className='address-heading-text'
                // style={{ color: theme.text }}
              >
                {phoneSection['title']}
              </h1>
              <p
                className='contact-header-detail-text subTitle'
                // style={{ color: theme.secondaryText }}
              >
                {phoneSection['subtitle']}
              </p>
              {/* <div className='address-btn-div'>
                <Button
                  text='Visit on Google Maps'
                  newTab={true}
                  href={addressSection.location_map_link}
                  // theme={theme}
                />
              </div> */}
            </div>
            <div className='address-heading-img-div'>
              <AddressImg />
            </div>
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default ContactGreeting;
